module.exports = __webpack_public_path__ + "img/cn_pocket-1.04e4d49.jpg";